import { addDays, isBefore } from 'date-fns';
import _ from 'underscore';

const prepareDates = (periods) => {
	const preparedDates = [];

	periods.forEach((period) => {
		if (_.isObject(period)) {
			let date = new Date(period.start);

			while (isBefore(date, new Date(period.end))) {
				preparedDates.push(date.toISOString());
				date = addDays(date, 1);
			}

			preparedDates.push(new Date(period.end).toISOString());
		} else {
			preparedDates.push(new Date(period).toISOString());
		}
	});

	return preparedDates;
};

export { prepareDates };
